import { inject, Injectable } from '@angular/core';
import { LoaderProgressService } from '../../shared/components/making-waves-loader/loader-progress.service';
import { uploadData } from 'aws-amplify/storage';
import { Amplify } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AmazonS3Service {

  private loaderProgressService = inject(LoaderProgressService);

  public async uploadFile(file: File, campaignId: string) {
    
    try {
      const bucketName = Amplify.getConfig().Storage?.S3?.bucket;
      const filePath = campaignId + "/content/" + file.name;
      console.log('S3 upload:', bucketName + '/' + filePath);
      const result = await uploadData({
        path: filePath,
        data: file,
        options: {
          contentType:file.type,
          onProgress: ({ transferredBytes, totalBytes }) => {
            if (totalBytes)
              this.loaderProgressService.updateProgress({ loaded: transferredBytes, total: totalBytes });
          }
        }
      }).result;      
      return Promise.resolve(result);
    } catch (error) {      
      console.error('Error : ', error);
      return Promise.reject(error);
    }
  }

}
